"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextModule = _interopRequireDefault(require("./Text.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Text = function Text(_ref) {
  var size = _ref.size,
      color = _ref.color,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_TextModule["default"].text, _TextModule["default"][size], _TextModule["default"][color])
  }, children);
};

Text.defaultProps = {
  size: 'md',
  color: 'regular'
};
Text.propTypes = {
  /** the font size */
  size: _propTypes["default"].oneOf(['x-lg', 'lg', 'md', 'sm']),

  /** the font's color */
  color: _propTypes["default"].oneOf(['regular', 'muted'])
};
var _default = Text;
exports["default"] = _default;